import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "nav-menu" }
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = { class: "user-name" }
const _hoisted_5 = {
  key: 0,
  class: "user-handle"
}

import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/authStore'
import { analytics } from '../services/analytics'


export default /*@__PURE__*/_defineComponent({
  __name: 'Navigation',
  setup(__props) {

const router = useRouter()
const { checkAuth, clearAuth } = useAuthStore()

const isAdmin = ref(false)
const userName = ref('')
const userHandle = ref('')
const userRole = ref('')

onMounted(async () => {
  try {
    // Use the auth store to get user info (with caching)
    const authData = await checkAuth()
    userName.value = authData.userName || 'User'
    userHandle.value = authData.userHandle || ''
    userRole.value = authData.role || ''
    isAdmin.value = authData.isAdmin || authData.role === 'Admin'
    console.log('Navigation: Auth data:', authData)
    console.log('Navigation: Is admin?', isAdmin.value)
    console.log('Navigation: Role:', authData.role)
  } catch (error) {
    console.error('Error checking auth status:', error)
  }
})

const onAdminClick = () => {
  console.log('🔐 Admin link clicked!')
  console.log('🔐 Current isAdmin value:', isAdmin.value)
  console.log('🔐 Current userRole value:', userRole.value)
  analytics.trackButtonClick('Admin Link', 'Navigation')
}

const signOut = async () => {
  try {
    try {
      await fetch(`${process.env.VUE_APP_API_BASE_URL}/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': 'application/json'
        }
      })
    } catch (error) {
      console.warn('Server logout failed, falling back to client-side:', error)
    }

    // Clear the auth store
    clearAuth()

    document.cookie = 'session_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain=.ngrok-free.app; Secure; SameSite=None'
    document.cookie = 'session_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Secure; SameSite=None'
    
    router.push('/sign-in')
          analytics.trackAuth('sign_out')
  } catch (error) {
    console.error('Error signing out:', error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "nav-brand" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Prec8",
        class: "logo"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (isAdmin.value)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/admin",
            class: "nav-item",
            onClick: onAdminClick
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Admin", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "nav-item"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Home", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/leaderboard",
        class: "nav-item"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Leaderboard", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/rewards",
        class: "nav-item"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Rewards Store", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/how-it-works",
        class: "nav-item"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("How it works", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_menu, null, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps(props, {
            variant: "text",
            class: "nav-item user-menu-btn"
          }), {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(userName.value), 1),
                (userHandle.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "@" + _toDisplayString(userHandle.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_v_icon, {
                icon: "mdi-chevron-down",
                class: "ml-1"
              })
            ]),
            _: 2
          }, 1040)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, { to: "/my-redemptions" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-history",
                        class: "mr-2"
                      }),
                      _cache[5] || (_cache[5] = _createTextVNode(" My Redemptions ", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, { onClick: signOut }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-logout",
                        class: "mr-2"
                      }),
                      _cache[6] || (_cache[6] = _createTextVNode(" Sign Out ", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})